import { Target, AlertCircle, ExternalLink, CheckCircle, Star, Trash2 } from 'lucide-react'

interface MetricsCardsProps {
  metrics: {
    total: number
    new: number
    starred: number
    relevant: number
    discarded: number
    exported: number
  }
  onMetricClick: (filterKey: string) => void
  activeMetricFilter?: string | null
}

function MetricsCard({ icon: Icon, label, value, color, onClick, isActive }: {
  icon: any
  label: string
  value: number
  color: string
  onClick: () => void
  isActive?: boolean
}) {
  return (
    <div
      onClick={onClick}
      className={`
        bg-white dark:bg-slate-800 p-4 rounded-lg border cursor-pointer transition-all hover:shadow-md
        ${isActive ? 'ring-2 ring-accent border-accent' : 'border-slate-200 dark:border-slate-700'}
      `}
    >
      <div className="flex items-center space-x-3">
        <Icon className={`w-5 h-5 ${color}`} />
        <div>
          <p className="text-xs text-slate-500 dark:text-slate-400">{label}</p>
          <p className="text-xl font-semibold text-slate-900 dark:text-white">{value}</p>
        </div>
      </div>
    </div>
  )
}

export default function MetricsCards({ metrics, onMetricClick, activeMetricFilter }: MetricsCardsProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      <MetricsCard 
        icon={Target}
        label="Total Number"
        value={metrics.total}
        color="text-slate-600 dark:text-slate-300"
        onClick={() => onMetricClick('total')}
        isActive={activeMetricFilter === 'total'}
      />
      <MetricsCard 
        icon={AlertCircle}
        label="New"
        value={metrics.new}
        color="text-blue-600 dark:text-blue-400"
        onClick={() => onMetricClick('new')}
        isActive={activeMetricFilter === 'new'}
      />
      <MetricsCard 
        icon={CheckCircle}
        label="Relevant"
        value={metrics.relevant}
        color="text-green-600 dark:text-green-400"
        onClick={() => onMetricClick('relevant')}
        isActive={activeMetricFilter === 'relevant'}
      />
      <MetricsCard 
        icon={Star}
        label="Starred"
        value={metrics.starred}
        color="text-yellow-600 dark:text-yellow-400"
        onClick={() => onMetricClick('starred')}
        isActive={activeMetricFilter === 'starred'}
      />
      <MetricsCard 
        icon={ExternalLink}
        label="Exported"
        value={metrics.exported}
        color="text-purple-600 dark:text-purple-400"
        onClick={() => onMetricClick('exported')}
        isActive={activeMetricFilter === 'exported'}
      />
      <MetricsCard 
        icon={Trash2}
        label="Discarded"
        value={metrics.discarded}
        color="text-red-600 dark:text-red-400"
        onClick={() => onMetricClick('discarded')}
        isActive={activeMetricFilter === 'discarded'}
      />
    </div>
  )
}